<header class="header full-width flex-row justify-between items-center">
  <h2 class="text-center" routerLink="/">Database Warranty Management</h2>

  <button mat-button [matMenuTriggerFor]="menu"
    class="user-menu-button cursor-pointer flex-row justify-between items-center" disableRipple="true">
    <mat-icon>account_circle</mat-icon>
    <div class="user-wrap text-left">
      <p class="title">{{userProfile?.username}}</p>
      @if (userProfile?.attributes?.company_name){
      <p class="subtitle">{{userProfile?.attributes?.company_name}}</p>
      }
    </div>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item>
      <span class="label">Name:</span> {{userProfile?.username}}
    </button>
    @if(userProfile?.attributes?.company_name){
    <button mat-menu-item>
      <span class="label">Company name:</span> {{userProfile?.attributes?.company_name}}
    </button>
    }
    @if(userProfile?.attributes?.company_id || userProfileTokenCompanyId){
    <button mat-menu-item>
      <span class="label">Company id:</span> {{userProfile?.attributes?.company_id || userProfileTokenCompanyId}}
    </button>
    }
    <!-- currently disabling edit until we need it -->
    @if(false){
    <button mat-menu-item>
      <img class="menu-icon" src="../../../../assets/images/edit.png" alt="edit user" /> Edit
    </button>
    }

    @if (isLoggedIn) {
    <button mat-menu-item (click)="logout()">
      <mat-icon class="menu-icon">logout</mat-icon> Logout
    </button>
    }
    @else {
    <button mat-menu-item (click)="login()">
      <mat-icon class="menu-icon">login</mat-icon> Login
    </button>
    }
  </mat-menu>
</header>